import {
    DayBookingState,
    DayBookingUsageType,
    WorkShiftTimeSlotState,
} from "../common/enums";
import { IIdTitle } from "../common/idTitle";
import { ICostCenterListItem } from "../costCenter/costCenterListItem";
import { DayBookingType } from "../dayBookingType/dayBookingType";
import { IWorkHoursItem } from "../workHours/workHoursItem";
import { IWorkShiftTimeSlot } from "../workShiftTimeSlot/workShiftTimeSlot";

export interface DayBooking {
    id: string;
    rowId: string;
    dayBookingTypeId: string;
    dayBookingTypeName: string;
    costCenterId: string;
    costCenterName: string;
    vehicleId: string;
    vehicleName: string;
    amount: number;
    state: DayBookingState;
    comment: string;
    day: string;
    endDay: string;
    dayUsageType: DayBookingUsageType;
    isAutomatic?: boolean;
}

export interface DayBookingEntry {
    id: string;
    workShiftTimeSlotId?: string;
    dayBookingTypeId: string;
    dayBookingTypeName: string;
    costCenterId: string;
    costCenterName: string;
    vehicleId: string;
    vehicleName: string;
    amount: number;
    state: DayBookingState;
    comment: string;
    day: string;
    endDay: string;
    dayUsageType: DayBookingUsageType;
    isAutomatic: boolean;
}

export const dayBookingToEntry = ({
    id,
    dayBookingTypeId,
    dayBookingTypeName,
    costCenterId,
    costCenterName,
    vehicleId,
    vehicleName,
    amount,
    state,
    comment,
    day,
    endDay,
    dayUsageType,
}: DayBooking): DayBookingEntry => ({
    id,
    dayBookingTypeId,
    dayBookingTypeName,
    costCenterId,
    costCenterName,
    vehicleId,
    vehicleName,
    amount,
    state,
    comment,
    day,
    endDay,
    dayUsageType,
    isAutomatic: false,
});

export const workHourToDayBookingEntry = (
    {
        workShiftId,
        category,
        salaryRowTypeId,
        costCenterId,
        vehicleId,
        amount,
        comment,
        dateStr,
    }: IWorkHoursItem,
    dayBookingTypes: DayBookingType[],
    costCenters: ICostCenterListItem[],
    vehicles: IIdTitle[],
    workShiftTimeSlots: IWorkShiftTimeSlot[]
): DayBookingEntry => {
    const type = dayBookingTypes?.find(
        (t) => t.salaryRowTypeId === salaryRowTypeId
    );
    const shiftSlots = workShiftTimeSlots.filter(
        (s) => s.workShiftId === workShiftId
    );
    return {
        id: `${workShiftId}.${category}`,
        workShiftTimeSlotId: shiftSlots[0]?.id,
        dayBookingTypeId: type?.id,
        dayBookingTypeName: type?.name,
        costCenterId,
        costCenterName: costCenters?.find((c) => c.id === costCenterId)?.name,
        vehicleId,
        vehicleName: vehicles?.find((v) => v.id === vehicleId)?.title,
        amount,
        state: shiftSlots.some((s) => s.state !== WorkShiftTimeSlotState.Locked)
            ? DayBookingState.UnLocked
            : DayBookingState.Locked,
        comment,
        day: dateStr,
        endDay: dateStr,
        dayUsageType: DayBookingUsageType.NotFullDay,
        isAutomatic: true,
    };
};
